import { InMemoryEntityModel } from "../../entity-model/in-memory-entity-model.js";
import { LOCAL_SEMANTIC_MODEL } from "../../model/known-models.js";
import { semanticModelEntitiesToSerialization, serializationToSemanticModelEntities, WritableSemanticModelAdapter, } from "../writable-semantic-model-adapter.js";
/**
 * @deprecated Use model store instead to manage the model state.
 */
export class InMemorySemanticModel extends WritableSemanticModelAdapter {
    baseIri = "";
    modelMetadata = {};
    constructor() {
        super(new InMemoryEntityModel());
        const id = this.getId();
        this.entityModel.entities[id] = { id, type: [LOCAL_SEMANTIC_MODEL], label: {} };
    }
    getBaseIri() {
        return this.baseIri;
    }
    setBaseIri(iri) {
        if (this.getMainEntity()?.source) {
            throw new Error("Semantic models having source specified cannot be directly modified.");
        }
        this.baseIri = iri;
    }
    serializeModel() {
        return {
            ...semanticModelEntitiesToSerialization(this.entityModel.entities),
            type: LOCAL_SEMANTIC_MODEL,
            baseIri: this.baseIri ?? "",
        };
    }
    deserializeModel(data) {
        const modelDescriptor = { ...data };
        const entities = serializationToSemanticModelEntities(modelDescriptor);
        const mainEntity = entities[modelDescriptor.modelId];
        this.baseIri = modelDescriptor.baseIri ?? mainEntity?.baseIri ?? "";
        this.entityModel.id = mainEntity?.id ?? modelDescriptor.modelId ?? this.getId();
        this.entityModel.entities = entities;
        this.modelMetadata = {};
        return this;
    }
}
//# sourceMappingURL=in-memory-semantic-model.js.map